import { css, keyframes, styled } from 'styled-components';
import { BREAKPOINTS } from '../../../../constants/layout.mjs';
import { theme } from '../../../../constants/theme.mjs';
import '../../../Container/index.mjs';
import { WrapPadding } from '../../../Container/Container.styles.mjs';
import '../../../ScrollWrapper/index.mjs';
import { ArrowIcon } from '../../../ScrollWrapper/ScrollWrapper.styles.mjs';
import '../../../StyleableSvgImage/index.mjs';
import { FIRST_LEVEL_MENU_HEIGHT } from '../FirstLevelMenu/FirstLevelMenu.styles.mjs';
import { Container as Container$1 } from '../../../Container/Container.mjs';
import { StyleableSvgImage } from '../../../StyleableSvgImage/StyleableSvgImage.mjs';
import { ScrollWrapper as ScrollWrapper$1 } from '../../../ScrollWrapper/ScrollWrapper.mjs';
"use strict";
const MICROSITE_MENU_Z_INDEX = theme.zIndex.header - 1;
const GLASS_COVER_Z_INDEX = MICROSITE_MENU_Z_INDEX - 1;
const HEADER_NAVIGATION_MICROSITE_MENU_HEIGHT = 130;
const TRANSITION_DURATION_MS = 250;
const withCssTransition = (properties, delay) => css`
  transition: ${TRANSITION_DURATION_MS}ms cubic-bezier(0.4, 0, 0.6, 1);
  transition-property: ${properties.join(",")};

  ${delay && css`
    transition-delay: ${delay}ms;
  `}
`;
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`;
const fadeInSmall = keyframes`
  from {
    opacity: 0;
    transform: translateY(-5px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`;
const Wrap = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  z-index: ${MICROSITE_MENU_Z_INDEX};
`;
const MenuWrap = styled.nav`
  background: ${({
  $motif
}) => theme.colors.menu.base[$motif]};
  display: grid;
  grid-template-rows: 1fr;
  height: 0;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  width: 100%;
  ${withCssTransition(["height", "opacity"])};

  ${({
  $slideInView
}) => $slideInView && css`
      padding-top: 48px;
      opacity: 1;
      height: 298px;
    `}
`;
const MenuInnerWrap = styled.div`
  display: flex;
  justify-content: center;
  opacity: 0;
  overflow: hidden;

  ${({
  $shouldShow
}) => $shouldShow && css`
      opacity: 1;
      padding: 20px 16px;
      min-height: 250px;
    `}
`;
const Container = styled(Container$1)`
  margin: 0;
  padding: 0;
  max-width: 1200px;
  overflow: hidden;

  ${WrapPadding} {
    flex-direction: row;
    align-items: flex-start;
    height: 207px !important;

    @media ${BREAKPOINTS.SMALL_MOBILE_AND_DOWN} {
      flex-direction: column;
      align-items: stretch;
    }
  }
`;
const PrimaryList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  min-width: 179px;
`;
const GridCardButton = styled.span`
  width: max-content;
  height: auto;
  color: ${theme.colors.primaryBlue};
  font-size: 13px;
  align-items: center;
  gap: 6px;
  font-weight: 400;
  display: flex;
  cursor: pointer;
  line-height: 16px;

  svg {
    flex-shrink: 0;
  }

  ${({
  $isRow
}) => $isRow && css`
      align-self: center;
    `};
`;
const ArrowRightIcon = styled(StyleableSvgImage)``;
const GridCardImagePlaceholder = styled.div`
  background: ${theme.colors.athensGreyLight};
  aspect-ratio: 1;
  width: 100%;
  height: 158px;
  border-radius: 4px;

  flex-shrink: 0;
`;
const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  flex-shrink: 1;
`;
const ActiveCursor = styled.span`
  position: absolute;
  width: 2px;
  height: 100%;
  background: ${theme.colors.primaryBlue};

  opacity: 0;

  ${withCssTransition(["opacity"])}

  right: -1px;
  top: 0;

  ${({
  $isActive
}) => $isActive && css`
      opacity: 1;
    `}
`;
const Link = styled.a`
  display: block;

  font-size: 16px;
  padding: 10px 0;
  line-height: normal;
  text-align: left;
  font-weight: ${theme.fontWeight.bold};

  ${withCssTransition(["transform", "opacity"])}

  border: none;
  outline: none;
  background: transparent;
  cursor: pointer;
  opacity: 0;
  transform: translateY(-3px);
  transition-duration: ${TRANSITION_DURATION_MS / 2}ms;
  transition-delay: ${TRANSITION_DURATION_MS / 2}ms;

  width: 100%;

  ${({
  $slideInView,
  $fadeInDelay
}) => $slideInView && css`
      transition-duration: ${TRANSITION_DURATION_MS}ms;
      ${$fadeInDelay && css`
        transition-delay: ${$fadeInDelay}ms;
      `}

      opacity: 1;
      transform: translateY(0);
    `}

  ${({
  $motif
}) => css`
    color: ${theme.colors.menu.micrositeSubMenuText[$motif]};

    &:focus:focus-visible {
      color: ${theme.colors.menu.active[$motif]};
    }
  `}
  
  ${({
  $active,
  $motif
}) => $active && css`
      color: ${theme.colors.menu.active[$motif]};
    `}
`;
const SecondaryWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;

  margin-left: 50px;
  border-left: 1px solid #242424;
  padding-left: 50px;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    width: 100%;
    min-width: 0;
  }

  @media ${BREAKPOINTS.SMALL_MOBILE_AND_DOWN} {
    margin: 20px 0 0;
    border-left: 0;
    border-top: 1px solid #242424;
    padding: 20px 0 0;
  }
`;
const ListItem = styled.li`
  list-style: none;
  margin: 0;

  line-height: normal;

  width: 100%;
  padding-right: 32px;
  position: relative;

  @media (hover: hover) and (pointer: fine) {
    &:focus-visible {
      a {
        color: ${theme.colors.primaryBlue};
      }
    }
  }
`;
const GlassCover = styled.div`
  pointer-events: ${({
  $show
}) => $show ? "all" : "none"};
  background: rgb(0 0 0 / 0.4);
  backdrop-filter: blur(20px);
  position: fixed;
  z-index: ${GLASS_COVER_Z_INDEX};
  inset: 0;
  top: ${FIRST_LEVEL_MENU_HEIGHT}px;
  height: calc(100% - ${FIRST_LEVEL_MENU_HEIGHT}px);

  opacity: 0;
  visibility: hidden;
  transition:
    opacity ${TRANSITION_DURATION_MS}ms ease-out 80ms,
    visibility ${TRANSITION_DURATION_MS}ms step-end 80ms;

  ${({
  $show
}) => $show && css`
      opacity: 1;
      visibility: visible;
      transition:
        opacity ${TRANSITION_DURATION_MS}ms ease-out 80ms,
        visibility ${TRANSITION_DURATION_MS}ms step-start 80ms;
    `}
`;
const RightWrap = styled.div`
  border-left: 1px solid #dee0e3;
  padding-left: 40px;
  width: 100%;
  height: 100%;
  min-width: 0;

  ${withCssTransition(["height"])}
`;
const ColumnList = styled.div`
  display: flex;
  justify-content: space-between;
  min-height: 186px;
  width: 100%;
  animation: ${fadeInSmall} ${TRANSITION_DURATION_MS}ms ease-out forwards;
  ${withCssTransition(["opacity"])}
`;
const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: ${({
  $width
}) => $width ?? 120}px;
  width: fit-content;
`;
const ColumnHeading = styled.span`
  font-size: 16px;
  font-weight: 700;
  line-height: 19.33px;
  color: #212327;
  cursor: default;
`;
const ColumnItem = styled.a`
  font-size: 13px;
  line-height: 15.7px;
  color: #212327;
`;
const SiteMapButton = styled.div`
  margin: auto auto 0 0;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;

  width: max-content;

  cursor: pointer;
`;
const SiteMapButtonLabel = styled.p`
  font-size: 12px;
  font-weight: 400;
  line-height: 14.5px;

  color: ${theme.colors.primaryBlue};

  margin: 0;
`;
const GridCard = styled.a`
  opacity: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
  cursor: pointer;
  width: 182px;
  background: transparent;
  outline: none;
  border: none;

  /* ${withCssTransition(["opacity", "transform"])} */
  ${({
  $slideInView,
  $fadeInDelay
}) => $slideInView && css`
      /* transition-duration: ${TRANSITION_DURATION_MS}ms;
      ${$fadeInDelay && css`
        transition-delay: ${$fadeInDelay}ms;
      `} */
      animation: ${fadeIn} ${TRANSITION_DURATION_MS}ms ease-out forwards;
      /* animation-delay: ${$fadeInDelay}ms; */
      opacity: 1;
      /* opacity: 1;
      transform: translateY(0); */
    `}

  &:hover {
    ${GridCardButton} svg,span {
      color: #338cff;
    }
  }

  &:focus-visible {
    border-bottom: 2px solid ${theme.colors.primaryBlue};
  }
`;
const GridCardImage = styled.img`
  width: 100%;
  height: 146px;
  border-radius: 4px;
  object-fit: contain;
  flex-shrink: 0;
`;
const GridCardLabel = styled.p`
  font-size: 16px;
  font-weight: 700;
  line-height: normal;
  color: #212327;
  margin: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box; /* stylelint-disable-line value-no-vendor-prefix */
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;

  text-align: ${({
  $isRow
}) => $isRow ? `center` : `left`};
`;
const ScrollWrapper = styled(ScrollWrapper$1)`
  border: none;

  ${ArrowIcon} {
    width: 50px;
    height: 50px;
    background: transparent;
    border-radius: 50%;
    box-shadow: 0 2px 12px rgb(0 0 0 / 0.25);
    right: 6px;
  }
`;
export { ActiveCursor, ArrowRightIcon, Column, ColumnHeading, ColumnItem, ColumnList, Container, GlassCover, GridCard, GridCardButton, GridCardImage, GridCardImagePlaceholder, GridCardLabel, HEADER_NAVIGATION_MICROSITE_MENU_HEIGHT, ItemContainer, Link, ListItem, MenuInnerWrap, MenuWrap, PrimaryList, RightWrap, ScrollWrapper, SecondaryWrap, SiteMapButton, SiteMapButtonLabel, TRANSITION_DURATION_MS, Wrap, withCssTransition };
//# sourceMappingURL=DropdownMenu.styles.mjs.map
